import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LogOut, ShieldCheck } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { adminLogout, getAdminToken } from '@/lib/api';

export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminArea = location.pathname.startsWith('/admin');
  const isLoggedIn = !!getAdminToken();

  const handleLogout = async () => {
    await adminLogout();
    navigate('/admin/login');
  };

  return (
    <header
      className="sticky top-0 z-30 w-full border-b border-border/60 bg-white/80 backdrop-blur"
      data-testid="app-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3" data-testid="header-home-link">
          <img
            src="/urjapod-logo.png"
            alt="UrjaPod Energy"
            className="h-14 w-auto sm:h-16"
            data-testid="header-logo"
          />
        </Link>
        <div className="flex items-center gap-3">
          <Badge
            variant="outline"
            className="hidden bg-accent text-accent-foreground sm:inline-flex"
          >
            Energy Bill Analyzer
          </Badge>
          <a
            href="https://www.urjapod.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden text-sm font-medium text-muted-foreground transition-colors duration-200 hover:text-primary sm:inline"
            data-testid="header-website-link"
          >
            urjapod.com
          </a>
          {isAdminArea && isLoggedIn ? (
            <Button
              variant="outline"
              size="sm"
              onClick={handleLogout}
              className="rounded-lg border-destructive/30 text-destructive hover:bg-destructive/5"
              data-testid="header-logout-button"
            >
              <LogOut className="mr-1.5 h-3.5 w-3.5" /> Sign out
            </Button>
          ) : (
            <Link to={isLoggedIn ? '/admin' : '/admin/login'} data-testid="header-admin-link">
              <Button variant="outline" size="sm" className="rounded-lg">
                <ShieldCheck className="mr-1.5 h-3.5 w-3.5" /> Admin
              </Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
